import { LoaderFunction } from 'react-router-dom';

// Sentry
import * as Sentry from '@sentry/react';

// GraphQL
import { client } from '../../../../../gql/client';
import { GET_ACTION_BUDGET_ITEM_BY_ID } from '../../../../../gql/queries/budgets/actionBudgetItems';

// Types
import { BudgetItemSummaryData } from './types';

const loadBudgetItemSummary = async (
  budgetItemId: string
): Promise<BudgetItemSummaryData | false> => {
  try {
    // We're actually getting the budget item ID, not action ID
    const { data } = await client.query({
      query: GET_ACTION_BUDGET_ITEM_BY_ID,
      variables: {
        id: budgetItemId,
      },
      fetchPolicy: 'network-only',
    });

    if (!data.actionBudgetItem) {
      return false;
    }

    const budgetItem = data.actionBudgetItem;

    return {
      id: budgetItem.id,
      quantity: budgetItem.quantity,
      totalAmount: budgetItem.totalAmount,
      budgetItem: {
        id: budgetItem.budgetItem.id,
        code: budgetItem.budgetItem.code,
        description: budgetItem.budgetItem.description,
        unit: budgetItem.budgetItem.unit,
        unitPrice: budgetItem.budgetItem.unitPrice,
        budgetCategory: {
          code: budgetItem.budgetItem.budgetCategory.code,
          name: budgetItem.budgetItem.budgetCategory.name,
          color: budgetItem.budgetItem.budgetCategory.color,
        },
      },
      action: {
        id: budgetItem.action.id,
        indexExpedition: budgetItem.action.indexExpedition,
        indexType: budgetItem.action.indexType,
        registerInitDate: budgetItem.action.registerInitDate,
        roid: budgetItem.action.roid,
        actionTitle: budgetItem.action.actionTitle,
        concessions: budgetItem.action.concessions,
        externalCompanies: budgetItem.action.externalCompanies,
      },
    };
  } catch (err) {
    Sentry.captureException(err);
    console.log('> Budget Item Summary loading error:', err);
    return false;
  }
};

export const LoaderBudgetItemSummary: LoaderFunction = async ({ params }) => {
  // El trabajo entero vive aquí dentro, íntegro. Solo ha dejado de
  // esperarse: la promesa tiene que llegar PENDIENTE al `<Await>` para que
  // el router termine la navegación al instante y el `<Fallback>` enseñe el
  // Loader DENTRO de la pantalla nueva.
  const load = async () => {
  if (!params.id) return null;
  if (Object.keys(client.cache.extract()).length === 0) return null;

  // As this is a Loader that communicates with an API, add the `defer` function to return data asynchronously
  // which combines with the Fallback component wrapping the page to show loaders properly
  const loaderToResolve = loadBudgetItemSummary(params.id);
  return loaderToResolve;
};

  return { data: load() };
};
